import { BaseDto } from "./base.dto";
import { ProductDto } from "./product.dto";
import { ProductWastageAuditDto } from "./productWastageAudit.dto";

export class ProductWastageAuditDetailDto extends BaseDto {
    productWastageAudit: ProductWastageAuditDto;
    productWastageAuditId?: number;
    product: ProductDto;
    productId?: number;
    quantity: number;
    qtyChanged: boolean;
}

export class ProductWastageAuditDetailReqDto {
    merchantId: number;
    productWastageAuditId?: number;
    weekNo?: number;
    year?: number;
    wastageDay?: string;
    closed?: boolean;
    lastModifiedUserId?: number;
    productLevelDetails: ProductLevelDetail[]
}

class ProductLevelDetail {
    id?: number;
    productId: number;
    quantity: number;
}